import i18n from "../i18n";
import React, { useEffect, useState } from "react";
import _ from "lodash";
import moment from "moment";
import {
  PageList,
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "./pageList";
import { Text, Tabs, Badge, Group, ActionIcon } from "@mantine/core";
import { IconRefresh } from "@tabler/icons";
import ReactJson from "react-json-view";
import { useCellRender } from "../hooks/useCellRender";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthUser } from "react-auth-kit";

import { useServerApi } from "../hooks/userServerApi";

const ClientCreditTransaction = ({ form, ...props }) => {
  const clientId = _.get(form.values, "_id");
  const [cellRender] = useCellRender();
  const [credit, setCredit] = useState(0);
  const [api] = useServerApi();
  const auth = useAuthUser();

  useEffect(() => {
    fetchCredit();
  }, [clientId]);

  const fetchCredit = async () => {
    try {
      if (!clientId) return;
      const credit = await api.Client.getAvailableCredit(clientId);
      // console.log("credit", credit);
      setCredit(credit.balance);
    } catch (error) {
      console.log(error);
    }
  };
  const formSchema = {
    display: {
      mode: ENUM_FORM_DISPLAY.FULLSCREEN,
      // size: "xl",     //xs, sm, xl  ....100%
      // position:"right"
    },
  };

  const tableSchema = {
    preQuery: { client: clientId },
    // select: ["code client amount remark withdraw deposit date"],
    columns: [
      {
        field: "date",
        headerName: "Date",
        sortable: true,
        cellRender: (col, data) =>
          data.date ? moment(data.date).format("YYYY-MM-DD") : "-",
      },
      {
        field: "code",
        headerName: "Code",
        sortable: true,
      },

      {
        field: "amount",
        headerName: "Amount",
        sortable: true,
        cellRender: (col, data) => (
          <Text color={data.amount < 0 ? "red" : "green"}>
            {cellRender.Currency(data.amount)}
          </Text>
        ),
      },
      {
        field: "remark",
        headerName: "Remark",
        sortable: true,
        cellRender: (col, data) => data.remark ?? "-",
      },
    ],
    // select: [
    //   "code",
    //   "client",
    //   "amount",
    //   "remark",
    //   "withdraw",
    //   "deposit",
    //   "date",
    // ],
  };

  // Debug logging
  // console.log("ClientCreditTransaction - clientId:", clientId);
  // console.log("ClientCreditTransaction - tableSchema:", tableSchema);

  return (
    <>
      {/* <ReactJson src={tableSchema} /> */}
      {/* {clientId} */}
      {/* {userRole} */}
      {!clientId && <Text size="xs">{i18n.t("No Client Id")}</Text>}
      {clientId && (
        <>
          <Group mb={10}>
            <Badge color="green" size="xs" radius={0}>{i18n.t("Available Credit")}</Badge>
            <Text size="xs">{cellRender.Currency(credit)}</Text>
            <ActionIcon
              variant="light"
              color="blue"
              size="sm"
              onClick={() => {
                fetchCredit();
              }}
              title="Refresh"
              style={{ marginLeft: 8 }}
            >
              <IconRefresh size={16} stroke={1.5} />
            </ActionIcon>
          </Group>
          <PageList
            title=""
            apiEntity="clientCreditTransaction"
            // initSort={{ by: "signedDate", order: "desc" }}
            hideSearchBar={true}
            tableSchema={tableSchema}
            formSchema={formSchema}
            hideActionButton={true}
            tablePadding={-10}
          />
        </>
      )}
    </>
  );
};

export default ClientCreditTransaction;
